import { useNavigate, useParams } from 'react-router-dom';
import React, { useState } from 'react';

import { AssessmentTemplate } from "../maincontent-physical/assessment-templete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import PhysicalImage from "../../../assets/Physical.png";
import EmotionalImage from "../../../assets/Emotional.png";
import RelationshipImage from "../../../assets/Relationship.png";
import AcceptanceImage from "../../../assets/Acceptance.png";
import LovingKindnessImage from "../../../assets/Loving-kindness.png";
import IntellectualImage from "../../../assets/Intellectual.png";
import { PhysicalDomain } from "../Components/PhysicalDomain";
import "./maincontent-physical.css";





export const MainContentPhysical = () => {
  const { domain } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  
  const domainData = {
    physical: {
      title: "Let’s Begin with Your Physical Well-Being 🌿",
      subtitle: "This domain encompasses your physical health and well-being, including the absence of pain and the ability to care for your body.",
      image: PhysicalImage,
      breadcrumb: "Physical Well Being",
    },
    emotional: {
      title: `GREAT PROGRESS, ${name}Let’s Begin with Your Emotional Well-Being 💖`,
      subtitle: "Your feelings matter. Let’s uncover what’s shaping your inner world.",
      image: EmotionalImage,
      breadcrumb: "Emotional Well Being",
    },
    relationships: {
      title: `GREAT PROGRESS, ${name}Let’s Begin with Your Relationships 🤝`,
      subtitle: "This domain represents your social connections, including those at work and in your personal life.",
      image: RelationshipImage,
      breadcrumb: "Relationship Well Being",
    },
    acceptance: {
      title: `GREAT PROGRESS, ${name}Let’s Begin with Your Acceptance 🕊️`,
      subtitle: "Financial 'Well-being' as a sense of acceptance and security regarding your financial situation. It's about feeling neither burdened by financial worries nor excessively materialistic.",
      image: AcceptanceImage,
      breadcrumb: "Acceptance Well Being",
    },
    "loving kindness": {
      title: `GREAT PROGRESS, ${name}Let’s Begin with Your Loving-Kindness 🌈`,
      subtitle: "This domain highlights compassion and goodwill towards yourself and others. It's about cultivating a sense of care and connection.",
      image: LovingKindnessImage,
      breadcrumb: "Loving-Kindness Well Being",
    },
    intellectual: {
      title: `GREAT PROGRESS, ${name}Let’s Begin with Your Intellectual Well-Being 🧠`,
      subtitle: "This domains focuses on your mental stimulation and growth, encompassing curiosity, learning, and critical thinking.",
      image: IntellectualImage,
      breadcrumb: "Intellectual Well Being",
    },
  };
  
  const content = domainData[domain];
  if (!content) return <p>Invalid domain.</p>;


  return (
    <AssessmentTemplate
      headerTitle="PEARLI Self-Assessment"
      headerSubtitle="Reflect on your well-being, one domain at a time"
      breadcrumbs={[
        { icon: faHouse, text: "Self Mindfulness" },
        { icon: faHouse, text: "PEARLI (General Life)" },
        { text: content.breadcrumb, active: true },
      ]}
      tags={["Physical", "Emotional", "Relationships", "Acceptance", "Loving Kindness", "Intellectual"]}
      title={content.title}
      subtitle={content.subtitle}
      image={content.image}
      badgeText="This takes 2–3 minutes in each domain. Your answers are private."
      buttonText="Start Your Reflection"
      onClick={() => navigate(PhysicalDomain)}
    />
  );
};




